import { Reveal } from "@/lib/motion";
import { FAQS } from "@/lib/site-data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr]">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
                <span className="h-px w-8 bg-[#E31B23]" /> FAQ
              </div>
              <h2 className="font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
                Questions, answered.
              </h2>
              <p className="mt-4 max-w-xs text-[#4b5563]">
                Still curious? Our team replies within one business hour.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.08}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-black/10">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left font-display text-lg font-semibold text-[#1F1F1F] hover:no-underline hover:text-[#5A189A] [&>svg]:text-[#E31B23]">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[#4b5563]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
